// frontend/src/services/groups.ts

import api from './api';

export interface Group {
  id: string;
  name: string;
  description: string;
  icon?: string;
  color?: string;
  merchant_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateGroupRequest {
  name: string;
  description?: string;
  icon?: string;
  color?: string;
}

export interface UpdateGroupRequest {
  name?: string;
  description?: string;
  icon?: string;
  color?: string;
}

// Admin APIs
export const adminListGroups = async () => {
  const response = await api.get('/admin/groups');
  return response.data;
};

export const adminGetGroup = async (groupId: string) => {
  const response = await api.get(`/admin/groups/${groupId}`);
  return response.data;
};

export const adminCreateGroup = async (data: CreateGroupRequest) => {
  const response = await api.post('/admin/groups', data);
  return response.data;
};

export const adminUpdateGroup = async (groupId: string, data: UpdateGroupRequest) => {
  const response = await api.put(`/admin/groups/${groupId}`, data);
  return response.data;
};

export const adminDeleteGroup = async (groupId: string) => {
  const response = await api.delete(`/admin/groups/${groupId}`);
  return response.data;
};

// Merchant APIs
export const getMerchantGroups = async () => {
  const response = await api.get('/merchant/groups');
  return response.data;
};
